export const enumCompanyStatus = {
    0 : "CreatingAccount",
    1 : "Active",
    2 : "Disabled",
    3 : "Invited"
}